export const TWITCH_LOGIN_DEAD_PREFIX = 'Your Twitch login no longer works'
export const YOUTUBE_LOGIN_DEAD_PREFIX = 'Your YouTube login no longer works'
export const TWITCH_LOGIN_MISMATCH_PREFIX = 'Your stored Twitch login no longer matches'
export const YOUTUBE_LOGIN_MISMATCH_PREFIX = 'Your stored YouTube login no longer opens'
export const LOGIN_CHECK_UNAVAILABLE_PREFIX = 'Could not check your '

export const LIVE_CHECK_REFUSAL_PREFIXES: string[] = [
  TWITCH_LOGIN_DEAD_PREFIX,
  YOUTUBE_LOGIN_DEAD_PREFIX,
  TWITCH_LOGIN_MISMATCH_PREFIX,
  YOUTUBE_LOGIN_MISMATCH_PREFIX,
  LOGIN_CHECK_UNAVAILABLE_PREFIX
]

export const LIVE_CHECK_LINK_PREFIXES: string[] = [
  TWITCH_LOGIN_DEAD_PREFIX,
  YOUTUBE_LOGIN_DEAD_PREFIX,
  TWITCH_LOGIN_MISMATCH_PREFIX,
  YOUTUBE_LOGIN_MISMATCH_PREFIX
]

export const needsLiveCheckConnectionsLink = (message: string): boolean =>
  LIVE_CHECK_LINK_PREFIXES.some((prefix) => message.startsWith(prefix))

export const isTwitchLoginDeadRefusal = (message: string): boolean =>
  message.startsWith(TWITCH_LOGIN_DEAD_PREFIX)
